"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactReduxI18n = require("react-redux-i18n");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _documents = require("../../../utils/documents");

var _jsxRuntime = require("react/jsx-runtime");

function DocumentVersionText(props) {
  var hasValidityStart = Boolean(props.document.validityStart);
  var hasValidityEnd = Boolean(props.document.validityEnd);

  function getDocumentPeriod() {
    if (_documents.DOCUMENT_STATES_VALID.includes(props.document.state)) {
      if (Boolean(props.document.validityStart) && (0, _momentTimezone.default)(props.document.validityStart).isAfter((0, _momentTimezone.default)())) {
        return 'FUTURE';
      }

      if (Boolean(props.document.validityEnd) && (0, _momentTimezone.default)(props.document.validityEnd).isBefore((0, _momentTimezone.default)())) {
        return 'PAST';
      }
    }

    return 'CURRENT';
  }

  function getStateLine() {
    var state = _reactReduxI18n.I18n.t("document.documentVersion.state.".concat(props.document.state), {
      interpolation: {
        escapeValue: false
      }
    });

    var line = _reactReduxI18n.I18n.t("document.documentVersion.stateLine.".concat(getDocumentPeriod(props.document)), {
      state: state
    });

    if (props.document.rejectionReason) {
      line += _reactReduxI18n.I18n.t('document.documentVersion.rejectionReason', {
        rejectionReason: props.document.rejectionReason
      });
    }

    return line;
  }

  function getValidityLine() {
    if (!hasValidityStart && !hasValidityEnd) {
      return '';
    }

    var I18nKey = '';

    if (hasValidityStart && !hasValidityEnd) {
      I18nKey = 'validityStartLine';
    }

    if (!hasValidityStart && hasValidityEnd) {
      I18nKey = 'validityEndLine';
    }

    if (hasValidityStart && hasValidityEnd) {
      I18nKey = 'validityFullLine';
    }

    return _reactReduxI18n.I18n.t("document.documentVersion.".concat(I18nKey), {
      validityStart: _reactReduxI18n.I18n.l(props.document.validityStart, {
        dateFormat: 'datetime.shortDate'
      }),
      validityEnd: _reactReduxI18n.I18n.l(props.document.validityEnd, {
        dateFormat: 'datetime.shortDate'
      })
    });
  }

  function renderFirstLine() {
    var render = getStateLine();

    if (_documents.DOCUMENT_STATES_VALID.includes(props.document.state)) {
      render += getValidityLine();
    }

    return render;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "text",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: renderFirstLine()
      }
    })
  });
}

DocumentVersionText.propTypes = {
  document: (0, _documents.documentVersionPropTypes)().isRequired
};
var _default = DocumentVersionText;
exports.default = _default;
//# sourceMappingURL=DocumentVersionText.js.map